/* eslint-disable no-unused-vars */
// @ts-nocheck
import {
  Grid,
  Typography,
  Box,
  Card,
  // List,
  // ListItem,
  Zoom,
  Button,
} from '@mui/material';
import PropTypes from 'prop-types';
import Keycloak from 'keycloak-js';
import TextField from '@mui/material/TextField';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { withTransaction } from '@elastic/apm-rum-react';
import utils from '../../utils/utils';
import useAuth from '../../Hooks/Auth/useAuth';
// import Gif from '../../assets/animated/BlueGifLogin.gif';
import LoginGraphic from '../../components/Common/LoginGraphic';
import useColorPallete from '../../Hooks/Settings/useColorPallete';
import { initializeAxiosForKeycloak } from '../../utils/AxiosKeyCloak';
import Loading from '../../components/Common/Loading';

/**
 * @function Organization
 * @description The login page for the application
 * @params {object} history - the history object used to navigate between pages
 * @returns {React.Component} - React component
 */
const Organization = ({ history }) => {
  const { user, verifyOrganization } = useAuth();
  const navigate = useNavigate();
  const [showButton, setShowButton] = useState(false);
  const { currentSavedTheme } = useColorPallete();

  const formValidationSchema = Yup.object({
    name: Yup.string()
      .required('Required')
      .max(320, 'name can contain at most 320 characters.'),
  });

  const handleSubmitForKeycloak = async (values) => {
    await utils.checkRealmValidityAndSetRealmId(values?.name);
    if (utils.showApplicationLauncher()) {
      window.location = '/launcher';
    } else {
      window.location = '/project/overview';
    }

    // const realmId = localStorage.getItem('REALM_ID');
    // if (!utils.isValueEmpty(realmId)) {
    //   const initOptions = {
    //     url: window.CONFIG.KEYCLOAK_URL,
    //     realm: realmId,
    //     clientId: 'Nimbus',
    //     onLoad: 'check-sso', // check-sso | login-required
    //     KeycloakResponseType: 'code',
    //   };

    //   const keycloakConfig = new Keycloak(initOptions);
    //   window.KEYCLOAK_CONFIG = keycloakConfig;

    // utils.initKeycloak();
    // initializeAxiosForKeycloak();
    // }
  };

  useEffect(() => {
    const browserLogo = currentSavedTheme?.browser_icon;
    if (browserLogo) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = browserLogo;
    }
  }, [currentSavedTheme]);
  const loginForm = useFormik({
    initialValues: {
      name: '',
    },
    enableReinitialize: true,
    validationSchema: formValidationSchema,
    onSubmit: async (values) => {
      if (window.CONFIG.KEYCLOAK_LOGIN === 'false') {
        try {
          const res = await verifyOrganization(values?.name);
          if (res) {
            localStorage.setItem('REALM_ID', values?.name);
            window.cookieStore.set('REALM_ID', values?.name);
            navigate('/login');
          }
        } catch (error) {
          console.log('Error checking realm validity:', error);
        }
      } else {
        await handleSubmitForKeycloak(values);
      }
    },
  });

  // useEffect(() => {
  //   if (window.CONFIG.KEYCLOAK_LOGIN === 'false') {
  //     loginForm.setFieldValue('name', window.CONFIG.ORG_NAME);
  //   }
  // }, []);

  const handleCacheClear = () => {
    navigate('/clear-client-storage');
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowButton(true);
    }, 5000); // 5 seconds

    // Cleanup timer on component unmount
    return () => clearTimeout(timer);
  }, []);

  return !utils.isValueEmpty(localStorage.getItem('REALM_ID')) ? (
    <Loading showClearStorageBtn={showButton} />
  ) : (
    <Grid
      item
      xs={12}
      container
      backgroundColor="white"
      height="100vh"
      sx={{ zIndex: 1, overflowX: 'auto' }}
    >
      <LoginGraphic />
      <Grid item xs={12} sm={12} md={6}>
        <Zoom in={true} mountOnEnter unmountOnExit timeout={800}>
          <Box display="flex" flexDirection="row" height="100%" flexGrow={1}>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              maxWidth="650px"
              flexGrow={1}
              marginX="auto"
              id="loginFormCards"
            >
              {/* fake block is added to avoid autocomplete in forms. Chrome is not honouring autoComplete="off" */}
              <Box display="none">
                <input name="name" type="text" />
              </Box>
              <Grid item xs={12} px={5}>
                <Card elevation={0}>
                  <Box pl={4} pr={4} pb={4} pt={1} mb={4}>
                    <Typography variant="h3" component="h1">
                      Get Started Now!
                    </Typography>

                    <Typography variant="body3">
                      Enter your credentials to access your account
                    </Typography>
                    <Box mb={5} mt={6}>
                      <TextField
                        required
                        id="name"
                        type="text"
                        name="name"
                        placeholder="Enter organization name"
                        variant="outlined"
                        autoComplete="off"
                        label="Organization"
                        value={loginForm.values.name}
                        onChange={loginForm.handleChange}
                        helperText={
                          loginForm.errors.name && loginForm.touched.name
                            ? loginForm.errors.name
                            : null
                        }
                        sx={(_theme) => {
                          return {
                            '& .MuiFilledInput-root': {
                              backgroundColor: `${_theme.palette.other.blue2} !important`,
                            },
                          };
                        }}
                        error={Boolean(
                          loginForm.errors.name && loginForm.touched.name
                            ? loginForm.errors.name
                            : null
                        )}
                      />
                    </Box>
                    <Box
                      display="flex"
                      alignItems="center"
                      flexGrow={1}
                      flexDirection="column"
                      mt={2}
                    >
                      <Button
                        size="large"
                        autoFocus
                        onClick={loginForm.handleSubmit}
                        disabled={user?.isLoading}
                        variant="contained"
                        color="primary"
                        type="submit"
                        fullWidth
                        sx={(_theme) => ({
                          // textTransform: 'none',
                          color: _theme?.palette?.other.white,
                        })}
                      >
                        {user.isLoading ? 'Loading...' : 'Login'}
                      </Button>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            </Box>
          </Box>
        </Zoom>
      </Grid>
    </Grid>
  );
};
Organization.propTypes = {
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default withTransaction('Organization', 'component')(Organization);
